import * as _ from "lodash";
import * as angular from "angular";
import { BoundsHelperService } from "../map/bounds.helper";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";

let UserActivityMapComponent = {
    selctor: "vcUserActivityMap",
    templateUrl:
        "/angular/components/user-map/user-activity-map.component.html",
    bindings: {
        filter: "=?",
        active: "=?",
        provider: "=?",
        selectedUser: "=?",
    },
    controller: class UserActivityMap {
        // * bindings for typescript compiler *
        public filter?: any;
        public active?: any;
        public provider?: any;
        public selectedUser?: any;
        // ************************************

        private $scope: any;
        private __env: any;
        private navigationBarService: NavigationBarHelperService;
        private uiGmapGoogleMapApi: any;
        private uiGmapIsReady: any;
        private boundsHelperService: BoundsHelperService;
        private $interval: any;

        public gmap: any;
        public hasBoundsChanged: boolean = false;
        public mapTimeout: any = null;
        public filterTimeout: any = null;
        public windowOpts: any = {};
        public markers: any;
        public map: any;
        public loadDisabled: boolean;
        public zoomLevelChanges: Array<any> = [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ];
        public centerUpdate: any;
        public mapEvents: any;
        public markerEvents: any;
        public screenSizeTimeout?: any;
        public oldFilter?: any;
        public topIndex?: any;
        public lastLoaded?: any;

        constructor(
            $scope: any,
            __env: any,
            $interval: any,
            NavigationBarHelperService: NavigationBarHelperService,
            uiGmapGoogleMapApi: any,
            uiGmapIsReady: any,
            BoundsHelperService: BoundsHelperService
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.navigationBarService = NavigationBarHelperService;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
            this.uiGmapIsReady = uiGmapIsReady;
            this.boundsHelperService = BoundsHelperService;
            this.$interval = $interval;

            this.centerUpdate = this.$interval(() => this.setMapCenter(), 2000);

            this.mapEvents = {
                bounds_changed: () => {
                    if (this.mapTimeout) {
                        clearTimeout(this.mapTimeout);
                    }
                    this.hasBoundsChanged = true;
                },
                idle: () => {
                    if (
                        this.gmap &&
                        !this.loadDisabled &&
                        this.filter.search.values == "" &&
                        !this.provider.infiniteItems.loading
                    ) {
                        if (this.mapTimeout) {
                            clearTimeout(this.mapTimeout);
                        }
                        this.mapTimeout = setTimeout(() => {
                            this.loadData(this.filter);
                        }, 500);
                    }
                },
            };
        }

        $onInit() {
            this.$scope.$watch(
                () => this.navigationBarService.screenSize,
                (newValue: string | null, oldValue: string | null) => {
                    if (newValue !== oldValue) {
                        clearTimeout(this.screenSizeTimeout);
                        this.screenSizeTimeout = setTimeout(() => {
                            this.provider.setScreenSize(newValue);
                        }, 500);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter,
                (newValue: any, oldValue: any) => {
                    if (oldValue && newValue !== oldValue) {
                        this.oldFilter = oldValue;
                        this.selectedUser.uid = null;

                        if (this.filterTimeout) {
                            clearTimeout(this.filterTimeout);
                        }

                        const searchCleared =
                            newValue.search.values == "" &&
                            oldValue.search &&
                            oldValue.search.values != "";

                        if (searchCleared) {
                            this.provider.zoom = 3;
                            this.provider.bounds = {
                                latitude: 30,
                                longitude: 10,
                            };
                            this.filterTimeout = setTimeout(() => {
                                this.loadMap(
                                    this.provider.bounds,
                                    this.provider.zoom
                                );
                            }, 500);
                        } else {
                            this.filterTimeout = setTimeout(() => {
                                this.loadData(this.filter);
                            }, 500);
                        }
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.selectedUser,
                (newValue: User | null, oldValue: User | null) => {
                    if (oldValue) {
                        if (!newValue.uid) {
                            this.windowOpts.show = false;
                        } else {
                            this.loadDisabled = true;
                            setTimeout(() => {
                                this.loadDisabled = false; //make it so it doesn't reload because the bounds changed to fit in label over pin
                            }, 1000);

                            this.windowOpts.show = true;
                            this.windowOpts.coords = {
                                latitude: this.selectedUser.lat,
                                longitude: this.selectedUser.lng,
                            };

                            let found = false;
                            angular.forEach(this.markers, (marker: any) => {
                                marker.show =
                                    marker.uid === this.selectedUser.uid;

                                if (marker.uid == this.selectedUser.uid) {
                                    found = true;
                                }
                            });

                            if (!found) {
                                this.loadDisabled = false;
                                this.map.zoom = 15;
                                this.map.center = {
                                    latitude: this.selectedUser.lat,
                                    longitude: this.selectedUser.lng,
                                };
                            }
                        }
                    }
                },
                true
            );

            this.markerEvents = {
                click: (marker: any, eventName: any, model: any) => {
                    if (model.uid) {
                        this.windowOpts.show = true;
                        this.windowOpts.coords = model.coords;
                        _.merge(this.selectedUser, model);
                    } else {
                        this.windowOpts.show = false;
                        this.map.zoom += 2;
                        this.map.center = model.coords;
                    }
                },
            };
            this.provider.bounds = null;
            this.markers = this.provider.markers;
        }

        initMap(): void {
            this.active.getLocalStorage();

            if (this.active.localInfo.userMap) {
                this.loadMap(
                    this.active.localInfo.userMap.center,
                    this.active.localInfo.userMap.zoom
                );
            } else {
                this.loadMap({ latitude: 30, longitude: 10 }, 3);
            }
        }

        loadMap(center: any, zoom?: number): void {
            this.uiGmapGoogleMapApi.then((map) => {
                if (!zoom) zoom = 12;
                this.map = {
                    center: center,
                    control: {},
                    zoom: zoom,
                    bounds: {},
                };

                this.uiGmapIsReady.promise().then(() => {
                    this.gmap = this.map.control.getGMap();
                    this.gmap.setOptions(this.boundsHelperService.getOptions());
                    this.loadData(this.filter);
                });
            });
        }

        loadMarkers(): void {
            this.provider.zoom = this.gmap.getZoom();
            this.provider
                .getMapMarkers()
                .then((markers: Object) => {
                    this.markers = markers;
                })
                .catch(() => {
                    this.provider.infiniteItems.loading = false;
                });
        }

        loadData(filter: Object): void {
            if (this.gmap && !this.loadDisabled) {
                this.topIndex = 0;
                let bounds = this.gmap.getBounds();
                if (
                    this.shouldReloadMarkers(bounds, this.map.zoom) ||
                    !angular.equals(filter, this.oldFilter)
                ) {
                    this.lastLoaded = {
                        bounds: _.cloneDeep(bounds),
                        zoom: this.map.zoom,
                    };
                    bounds = {
                        southwest: bounds.getSouthWest(),
                        northeast: bounds.getNorthEast(),
                    };
                    this.provider.setFilters(this.filter, bounds);
                    this.loadMarkers();
                }
            }
        }

        shouldReloadMarkers(bounds: Object | null, zoom: number): boolean {
            if (!this.markers) return false;
            if (this.zoomChanged(zoom)) return true;
            if (
                this.lastLoaded.bounds &&
                !this.boundsHelperService.boundsContainsBounds(
                    this.lastLoaded.bounds,
                    bounds
                )
            )
                return true; //has moved outside of last bounds
            return false;
        }

        zoomChanged(zoom: number): boolean {
            if (!this.lastLoaded || !this.lastLoaded.zoom) return true;
            for (let i = 0; i < this.zoomLevelChanges.length; i++) {
                if (
                    (this.lastLoaded.zoom < this.zoomLevelChanges[i] &&
                        zoom >= this.zoomLevelChanges[i]) ||
                    (this.lastLoaded.zoom >= this.zoomLevelChanges[i] &&
                        zoom < this.zoomLevelChanges[i])
                ) {
                    return true; // last zoom was in a zoom level and new one has left it. Markers will be rounded differently so reload
                }
            }
            return false;
        }

        setMapCenter(): void {
            if (!this.hasBoundsChanged || !this.active) return;
            if (!this.active.localInfo) {
                this.active.localInfo = {};
            }
            this.active.localInfo.userMap = {
                center: this.map.center,
                zoom: this.map.zoom,
            };
            this.active.saveLocalStorage();
            this.hasBoundsChanged = false;
        }

        $onDestroy(): void {
            if (this.centerUpdate) {
                this.$interval.cancel(this.centerUpdate);
            }
        }
    },
};

angular
    .module("userMap", [])
    .component(UserActivityMapComponent.selctor, UserActivityMapComponent);
